const Turbo = window.Turbo

const ensureModal = () => {
  let dialog = document.getElementById("turbo-confirm-modal")

  if (dialog) return dialog

  dialog = document.createElement("dialog")
  dialog.id = "turbo-confirm-modal"
  dialog.className = "modal"
  dialog.innerHTML = `
    <form method="dialog" class="modal-box space-y-4">
      <h3 class="text-lg font-bold text-base-content">Confirm Action</h3>
      <p id="turbo-confirm-message" class="text-base-content/70"></p>
      <div class="modal-action">
        <button type="button" class="btn" value="cancel">Cancel</button>
        <button type="submit" class="btn btn-primary" value="confirm">Proceed</button>
      </div>
    </form>
    <form method="dialog" class="modal-backdrop">
      <button>close</button>
    </form>
  `

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof HTMLButtonElement)) return
    if (!dialog.contains(event.target)) return
    if (event.target.value === "cancel") {
      dialog.close("cancel")
    }
  })

  document.body.appendChild(dialog)
  return dialog
}

const confirmWithModal = (message) => {
  const dialog = ensureModal()
  const messageElement = dialog.querySelector("#turbo-confirm-message")

  if (messageElement) messageElement.textContent = message

  return new Promise((resolve) => {
    const handleClose = () => {
      dialog.classList.remove("modal-open")
      resolve(dialog.returnValue === "confirm")
      dialog.removeEventListener("close", handleClose)
    }

    dialog.addEventListener("close", handleClose, { once: true })

    if (typeof dialog.showModal === "function") {
      dialog.showModal()
    } else {
      dialog.classList.add("modal-open")
    }
  })
}

function setConfirmMethod() {
  if (Turbo?.config?.forms) {
    Turbo.config.forms.confirm = confirmWithModal
    return true
  }
  return false
}

if (!setConfirmMethod()) {
  document.addEventListener("turbo:load", setConfirmMethod, { once: true })
}

function extractConfirmMessage(form, submitter) {
  const submitterMessage = submitter?.getAttribute?.("data-turbo-confirm")
  if (submitterMessage) return submitterMessage

  const formMessage = form?.getAttribute?.("data-turbo-confirm")
  if (formMessage) return formMessage

  return null
}

const confirmedSubmissions = new WeakSet()

// Turbo doesn't intercept `data-turbo="false"` forms (or forms inside a
// `data-turbo="false"` container), but we still want the same DaisyUI confirm
// modal for them (e.g. full page reload actions like recursion).
document.addEventListener(
  "submit",
  async (event) => {
    const form = event.target
    if (!(form instanceof HTMLFormElement)) return
    if (!form.closest('[data-turbo="false"]')) return

    const message = extractConfirmMessage(form, event.submitter)
    if (!message) return

    if (confirmedSubmissions.has(form)) {
      confirmedSubmissions.delete(form)
      return
    }

    event.preventDefault()

    const confirmed = await confirmWithModal(message)
    if (!confirmed) return

    confirmedSubmissions.add(form)
    if (typeof form.requestSubmit === "function") {
      if (event.submitter) {
        form.requestSubmit(event.submitter)
      } else {
        form.requestSubmit()
      }
    } else {
      form.submit()
    }
  },
  true
)

export { confirmWithModal }
